import { z } from 'zod';

/**
 * Cycle de vie du consentement RGPD du prospect (capturé via OTP SMS).
 *
 *   - `verified` : SMS validé live au moment du wizard. Cas par défaut,
 *     livraison Collect/Hopti déclenchée immédiatement.
 *   - `pending_offline` : lead créé hors-ligne — le SMS partira au sync,
 *     le vendeur a 1h depuis la création offline (cf. `consentExpiresAt`)
 *     pour saisir le code via le modal "saisie a posteriori". Tant que
 *     pending_offline, la livraison est gatée.
 *   - `expired` : 1h dépassée OU code SMS invalidé (>30 min depuis envoi).
 *     Statut terminal, pas de retransmission.
 */
export const ConsentStatus = {
  verified: 'verified',
  pending_offline: 'pending_offline',
  expired: 'expired',
} as const;

export type ConsentStatus = (typeof ConsentStatus)[keyof typeof ConsentStatus];

export const ConsentStatusSchema = z.nativeEnum(ConsentStatus);

/** TTL du code SMS dans le mode différé (depuis SmsLog.sentAt). */
export const CONSENT_OTP_TTL_MS = 30 * 60 * 1000;

/** TTL du lead pending_offline (depuis Lead.createdAt). */
export const CONSENT_LEAD_TTL_MS = 60 * 60 * 1000;
